// extracted by mini-css-extract-plugin
export default {"button":"controlButton_button__6zUme"};